var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.4398 7.56002L8.78646 23.2133C8.19979 23.8 7.21311 23.72 6.73311 23.0267C5.07978 20.6133 4.10645 17.76 4.10645 14.8267V8.97335C4.10645 7.88002 4.93312 6.64002 5.94645 6.22669L13.3731 3.18669C15.0531 2.49335 16.9198 2.49335 18.5998 3.18669L23.9865 5.38668C24.8798 5.74668 25.1064 6.89335 24.4398 7.56002Z",
    fill: "#1ACEB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6937 9.38667C26.5603 8.65333 27.8803 9.27999 27.8803 10.4133V14.8266C27.8803 21.3466 23.147 27.4533 16.6804 29.24C16.2404 29.36 15.7604 29.36 15.307 29.24C13.4137 28.7066 11.6537 27.8133 10.147 26.64C9.50699 26.1467 9.44034 25.2133 10.0003 24.64C12.907 21.6667 21.4137 13 25.6937 9.38667Z",
    fill: "#1ACEB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.9a5bc0d93021cf69d5f0a8d6fb2e4b6e.svg";
export { ForwardRef as ReactComponent };